/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { useHookstate } from '@hookstate/core'
import StandardModal from '~/components/StandardModal'
import { useLang } from '~/hooks/useLang'
import RegistrationTab from '~/features/Dispatch/components/DispatchRegistrationTab'
import './styles.scss'
import ScreenSettingsDraggableProps from '~/features/Entry/interfaces/IPositionDraggable'
import { authFetch } from '~/services/fetch'
import useSystemState from '~/features/System/stores/SystemState'
import { storeScreenSettings } from '~/features/System/services'
import { Typography } from '@mui/material'
import useDispatchRegistrationState from '~/features/Dispatch/stores/DispatchRegistrationState'

const modal = document.getElementById('div-modal') as HTMLElement

export default function RegistrationModalDraggable() {
  const { translate } = useLang();
  const { windowManager, loadingButton } = useSystemState();
  const { registrationDispatch } = useDispatchRegistrationState();
  const { openForm } = registrationDispatch();
  const getPositionsDraggable = useHookstate<ScreenSettingsDraggableProps>({
    id: 0,
    user_id: 0,
    url: '',
    window_name: '',
    x_position: 80,
    y_position: 141,
    is_window_open: true,
    is_window_minimized: false,
    created_at: new Date().toJSON(),
    updated_at: new Date().toJSON(),
    deleted_at: null
  })
  

  useEffect(() => {
    authFetch({
      url: '/screen-setting/get-user-settings',
      method: 'POST',
      data: {
        url: location.pathname,
      }
    }).then((response) => {
      if ('RegistrationModalDraggable' in response.data) {
        getPositionsDraggable.set(response.data.RegistrationModalDraggable)
      }
    })

    return () => {
      windowManager()['registration'].open.set(false)
    }
  }, [])

  const handleStop = (event, dragElement) => {
    event.stopPropagation();
    event.preventDefault();

    windowManager()['registration'].merge({
      positionX: dragElement.x,
      positionY: dragElement.y,
    })
  };

  const closeDraggable = () => {
    if (!windowManager()['registration'].disabled.value) {
      windowManager()['registration'].open.set(false);
    }
    openForm.set(false);
  };

  useEffect(() => {
    return () => {
      storeScreenSettings({
        windowName: 'RegistrationModalDraggable',
        isOpen: windowManager()['registration'].open.get(),
        isMinimized: windowManager()['registration'].minimized?.get(),
        positionX: windowManager()['registration']?.positionX?.get(),
        positionY: windowManager()['registration']?.positionY?.get(),
      })
    }
  }, [
    windowManager()['registration'].open.get(),
    windowManager()['registration'].minimized.get(),
    windowManager()['registration'].positionY.get(),
    windowManager()['registration'].positionX.get(),
  ])

  if (windowManager()['registration'].open.get()) {
    return ReactDOM.createPortal(
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {!loadingButton.get() && (
          <StandardModal
            title={
              <Typography variant='h5'>{translate('Registration of Qualifiers')}</Typography>
            }
            dimensions={{
              width: 1000,
              
            }}
            handleStop={handleStop}
            position={{
              x: windowManager()['registration'].positionX?.get() ? Number(windowManager()['registration'].positionX?.get()) : 300,
              y: windowManager()['registration'].positionY?.get() ? Number(windowManager()['registration'].positionY?.get()) : 200,
            }}
            closeButton={() => closeDraggable()}
            isExpanded={getPositionsDraggable.is_window_minimized}
            sxContent={{paddingX: 0}}
          >
            {getPositionsDraggable.is_window_minimized && (
              <RegistrationTab />
            )}
          </StandardModal>
        )}
      </>,
      modal
    )
  } else {
    return <></>
  }
}
